(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nx-review-modal-locale"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const data = document.getElementById('nx-review-form-locale');
    if (!data) return;
    const {language,pairs} = JSON.parse(data.textContent);
    const translations = new Map(pairs);
    const observed = new WeakSet();
    const translate = (modal) => {
      const walker = document.createTreeWalker(modal,NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('script,style,textarea,input,.jdgm-write-review-modal__product-title')) continue;
        const raw = node.nodeValue;
        const key = raw.trim().replace(/\s+/g,' ');
        const replacement = translations.get(key);
        if (replacement && replacement !== key) node.nodeValue = raw.replace(raw.trim(),replacement);
      }
      for (const element of [modal,...modal.querySelectorAll('[aria-label],[placeholder],[title]')]) {
        for (const attribute of ['aria-label','placeholder','title']) {
          const current = element.getAttribute(attribute);
          const replacement = translations.get(current);
          if (replacement && replacement !== current) element.setAttribute(attribute,replacement);
        }
      }
      for (const stars of modal.querySelectorAll('.jdgm-write-review-modal__stars')) {
        stars.dataset.nxPoor = translations.get('Poor');
        stars.dataset.nxGreat = translations.get('Great');
      }
    };
    const attach = (modal) => {
      if (observed.has(modal)) return;
      observed.add(modal);
      modal.dataset.nxLanguage = language;
      modal.setAttribute('lang',language);
      translate(modal);
      let pending = false;
      const observer = new MutationObserver(() => {
        if (pending) return;
        pending = true;
        queueMicrotask(() => {
          observer.disconnect();
          translate(modal);
          pending = false;
          observer.observe(modal,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','placeholder','title']});
        });
      });
      observer.observe(modal,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-label','placeholder','title']});
    };
    const discover = (root) => {
      if (!(root instanceof Element)) return;
      if (root.matches('.jdgm-write-review-modal')) attach(root);
      root.querySelectorAll('.jdgm-write-review-modal').forEach(attach);
    };
    discover(document.body);
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) discover(node);
    }).observe(document.body,{subtree:true,childList:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-review-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-review-rating')) {
  const requests = new Map();
  const endpoint = 'https://api.judge.me/reviews/reviews_for_widget';
  async function productReviews(shop, productId) {
    const key = shop + '/' + productId;
    let record = requests.get(key);
    if (!record || Date.now() - record.time > 30000) {
      const promise = (async () => {
        const readPage = async page => {
          const params = new URLSearchParams({shop_domain:shop, platform:'shopify', product_id:productId, page:String(page), per_page:'100'});
          const response = await fetch(endpoint + '?' + params, {signal:AbortSignal.timeout(12000), credentials:'omit'});
          if (!response.ok) throw new Error('Reviews unavailable');
          const data = await response.json();
          if (String(data.product_external_id) !== productId || !Array.isArray(data.reviews)) throw new Error('Review product mismatch');
          if (data.multi_language_sorting_enabled) throw new Error('Review pagination requires language handling');
          if (Number(data.pagination?.current_page) !== page) throw new Error('Invalid review page');
          return data;
        };
        const first = await readPage(1);
        const pages = Number(first.pagination?.total_pages);
        const total = Number(first.number_of_reviews);
        if (!Number.isInteger(pages) || pages < 0 || !Number.isInteger(total) || total < 0) throw new Error('Invalid review count');
        const all = [...first.reviews];
        for (let page = 2; page <= pages; page++) {
          const next = await readPage(page);
          if (Number(next.number_of_reviews) !== total || Number(next.pagination.total_pages) !== pages) throw new Error('Reviews changed while loading');
          all.push(...next.reviews);
        }
        const unique = new Map(all.map(review => [review.uuid, review]));
        if (unique.has(undefined) || unique.size !== total) throw new Error('Incomplete review set');
        const reviews = [...unique.values()].filter(review => {
          if (typeof review.is_for_product_from_group !== 'boolean' || typeof review.is_for_product_from_bundle !== 'boolean') throw new Error('Missing review ownership');
          return !review.is_for_product_from_group && !review.is_for_product_from_bundle;
        });
        if (reviews.some(review => !Number.isInteger(review.rating) || review.rating < 1 || review.rating > 5)) throw new Error('Invalid review rating');
        return {reviews, count:reviews.length, rating:reviews.length ? reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length : 0};
      })();
      record = {time:Date.now(), promise};
      requests.set(key, record);
      promise.catch(() => {if (requests.get(key) === record) requests.delete(key);});
    }
    return record.promise;
  }
  function reviewCount(element, count) {
    const category = new Intl.PluralRules(element.dataset.locale || 'en').select(count);
    const key = 'count' + category[0].toUpperCase() + category.slice(1);
    return (element.dataset[key] || element.dataset.countOther).replaceAll('__COUNT__', String(count));
  }
  function textNode(tag, value, className) {
    const element = document.createElement(tag);
    element.textContent = value || '';
    if (className) element.className = className;
    return element;
  }
  function plainText(html) {
    const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    doc.querySelectorAll('script,style,iframe,object').forEach(node => node.remove());
    doc.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
    doc.querySelectorAll('p,div,li').forEach(node => node.append('\n'));
    return doc.body.textContent.trim();
  }
  class NaturexReviewRating extends HTMLElement {
    connectedCallback() {
      this.refresh = () => this.load();
      window.addEventListener('focus', this.refresh);
      this.load();
    }
    disconnectedCallback() {window.removeEventListener('focus', this.refresh);}
    async load() {
      const link = this.querySelector('a');
      const status = this.querySelector('[role="status"]');
      try {
        const {count, rating} = await productReviews(this.dataset.shop, this.dataset.productId);
        if (!this.isConnected) return;
        this.querySelector('.nx-review-summary__stars').hidden = count === 0;
        this.querySelector('.nx-review-summary__stars-fill').style.width = (rating * 20) + '%';
        this.querySelector('.nx-review-summary__score').textContent = count ? rating.toFixed(1) + '/5' : '';
        this.querySelector('.nx-review-summary__count').textContent = reviewCount(this, count);
        link.setAttribute('aria-label', count ? this.dataset.ratingLabel.replace('__RATING__', rating.toFixed(1)).replace('__REVIEW_COUNT__', reviewCount(this, count)) : this.dataset.empty);
        link.hidden = count === 0;
        status.hidden = count > 0;
        status.textContent = this.dataset.empty;
      } catch (error) {
        if (!this.isConnected) return;
        link.hidden = true;
        status.hidden = false;
        status.textContent = this.dataset.error;
      }
    }
  }
  class NaturexProductReviews extends HTMLElement {
    connectedCallback() {
      this.limit = 6;
      this.status = this.querySelector('[data-nx-status]');
      this.list = this.querySelector('[data-nx-review-list]');
      this.more = this.querySelector('[data-nx-more]');
      this.sort = this.querySelector('select');
      this.retry = this.querySelector('[data-nx-retry]');
      this.write = this.querySelector('[data-nx-write]');
      this.more.onclick = () => {this.limit += 6; this.render();};
      this.sort.onchange = () => {this.limit = 6; this.render();};
      this.retry.onclick = () => {requests.delete(this.dataset.shop + '/' + this.dataset.productId); this.load();};
      this.write.onclick = () => this.openForm();
      this.refresh = () => this.load();
      window.addEventListener('focus', this.refresh);
      this.load();
      if (this.closest('nx-review-room') && location.hash === '#write-review') this.openForm();
    }
    disconnectedCallback() {window.removeEventListener('focus', this.refresh);}
    async load() {
      this.setAttribute('aria-busy', 'true');
      this.retry.hidden = true;
      try {
        this.data = await productReviews(this.dataset.shop, this.dataset.productId);
        if (this.isConnected) this.render();
      } catch (error) {
        if (!this.isConnected) return;
        this.list.replaceChildren();
        this.more.hidden = true;
        this.sort.parentElement.hidden = true;
        this.status.textContent = this.dataset.error;
        this.status.hidden = false;
        this.retry.hidden = false;
        this.dispatchEvent(new CustomEvent('nx:reviews-error', {bubbles:true, detail:this.dataset.error}));
      } finally {this.setAttribute('aria-busy', 'false');}
    }
    render() {
      const room = this.closest('nx-review-room');
      const ratingFilter = room?.querySelector('[data-nx-rating-filter]')?.value || 'all';
      const photosOnly = room?.querySelector('[data-nx-photos-filter]')?.checked || false;
      const reviews = this.data.reviews.filter(review => (ratingFilter === 'all' || review.rating === Number(ratingFilter)) && (!photosOnly || (review.pictures_urls || []).length > 0));
      this.dispatchEvent(new CustomEvent('nx:reviews-loaded', {bubbles:true, detail:this.data}));
      const recent = (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at);
      reviews.sort(this.sort.value === 'highest' ? (a,b) => b.rating - a.rating || recent(a,b) : this.sort.value === 'lowest' ? (a,b) => a.rating - b.rating || recent(a,b) : recent);
      this.status.hidden = reviews.length > 0;
      this.status.textContent = this.data.count && !reviews.length ? (this.dataset.noMatch || this.dataset.empty) : this.dataset.empty;
      this.sort.parentElement.hidden = this.data.count < 2;
      this.more.hidden = reviews.length <= this.limit;
      this.list.replaceChildren(...reviews.slice(0, this.limit).map(review => this.card(review)));
    }
    card(review) {
      const card = textNode('article', '', 'nx-own-review');
      card.dataset.reviewId = review.uuid;
      card.dataset.productId = this.dataset.productId;
      const stars = textNode('div', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating), 'nx-own-review__stars');
      stars.dir = 'ltr';
      stars.setAttribute('aria-label', review.rating + '/5');
      const title = textNode('h3', review.reviewer_name || this.dataset.anonymous);
      const date = textNode('time', '');
      if (Number.isFinite(Date.parse(review.created_at))) {
        date.dateTime = review.created_at;
        date.textContent = new Intl.DateTimeFormat(this.dataset.locale || 'en', {year:'numeric',month:'short',day:'numeric',timeZone:'UTC'}).format(new Date(review.created_at));
      }
      card.append(stars, title, date);
      if (review.verified_buyer === true) card.append(textNode('span', this.dataset.verified, 'nx-own-review__verified'));
      if (review.title) {
        const reviewTitle = textNode('p', review.title, 'nx-own-review__title');
        reviewTitle.dir = 'auto';
        card.append(reviewTitle);
      }
      const body = plainText(review.body_html);
      const disclosedExperience = [review.title, body].filter(Boolean).join(' ');
      const mentionsFree = /(?:\bfor free\b|\bfree (?:samples?|trials?|products?|packets?|packs?)\b|\bücretsiz\b|مج[ّ]?ان[يية])/iu.test(disclosedExperience);
      const mentionsSample = /(?:\bsamples?\b|\btrial(?:s| packet| pack| dose)?\b|\bnumune(?:si|yi|ler)?\b|\bdeneme(?:si|yi)?\b|عي[ّ]?ن[ةه]|عينات|عبوة تجريبية)/iu.test(disclosedExperience);
      const experienceLabel = mentionsFree && this.dataset.freeSample ? this.dataset.freeSample : mentionsSample ? this.dataset.sample : '';
      if (experienceLabel) card.append(textNode('span', experienceLabel, 'nx-own-review__sample'));
      const reviewBody = textNode('p', body, 'nx-own-review__body');
      reviewBody.dir = 'auto';
      card.append(reviewBody);
      const translationText = [review.title, body].filter(Boolean).join('\n\n').trim();
      if (translationText && this.dataset.translateLabel) {
        const excerpt = translationText.length > 5000;
        const translation = textNode('a', excerpt ? this.dataset.translateExcerpt : this.dataset.translateLabel, 'nx-own-review__translate');
        const destination = new URL('https://translate.google.com/');
        destination.searchParams.set('sl', 'auto');
        destination.searchParams.set('tl', (this.dataset.locale || 'en').split('-')[0]);
        destination.searchParams.set('text', translationText.slice(0, 5000));
        destination.searchParams.set('op', 'translate');
        translation.href = destination.href;
        translation.target = '_blank';
        translation.rel = 'noopener noreferrer';
        translation.referrerPolicy = 'no-referrer';
        translation.title = this.dataset.translateTitle || this.dataset.translateLabel;
        card.append(translation);
      }
      if (review.reply_content) {
        const reply = textNode('blockquote', '', 'nx-own-review__reply');
        const replyBody = textNode('p', plainText(review.reply_content));
        replyBody.dir = 'auto';
        reply.append(textNode('strong', this.dataset.reply), replyBody);
        card.append(reply);
      }
      for (const picture of review.pictures_urls || []) {
        const src = typeof picture === 'string' ? picture : picture.original || picture.compact || picture.small;
        if (!src || !/^https:\/\//.test(src)) continue;
        const link = document.createElement('a');
        link.href = src;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        const image = document.createElement('img');
        image.src = src;
        image.alt = this.dataset.photo;
        image.loading = 'lazy';
        image.width = 120;
        image.height = 120;
        link.append(image);
        card.append(link);
      }
      return card;
    }
    async openForm() {
      if (!this.closest('nx-review-room')) {
        const link = this.querySelector('.nx-review-summary__rating,.nx-review-summary__link');
        if (link) {
          const destination = new URL(link.href, location.href);
          if (destination.origin === location.origin && destination.searchParams.get('view') === 'nx-reviews') {
            destination.hash = 'write-review';
            location.assign(destination.href);
            return;
          }
        }
      }
      if (this.openingForm || !this.isConnected) return;
      this.openingForm = true;
      this.write.disabled = true;
      const formIsOpen = () => Array.from(document.querySelectorAll('.jdgm-write-review-modal')).some(modal => modal.getClientRects().length && getComputedStyle(modal).visibility !== 'hidden');
      try {
        let candidate;
        let readySince = 0;
        let lastClick = 0;
        for (let attempt = 0; attempt < 60; attempt++) {
          if (!this.isConnected || formIsOpen()) return;
          const source = this.closest('.nx-review-panel')?.querySelector('[data-nx-form-source]');
          const button = source?.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link');
          const now = Date.now();
          if (button !== candidate) {
            candidate = button;
            readySince = now;
          }
          if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true' && now - readySince >= 250 && (!lastClick || now - lastClick >= 1500)) {
            window.jdgmSettings = window.jdgmSettings || {};
            window.jdgmSettings.request_store_review_after_product_review = false;
            button.click();
            lastClick = now;
          }
          await new Promise(resolve => setTimeout(resolve, 250));
        }
        if (this.isConnected && !formIsOpen()) throw new Error('Review form unavailable');
      } catch (error) {
        if (this.isConnected) {
          this.status.textContent = this.dataset.formError;
          this.status.hidden = false;
        }
      } finally {
        this.openingForm = false;
        this.write.disabled = false;
      }
    }
  }
  const closeSelector = '.jdgm-write-review-modal .jdgm-write-review-modal__close-btn';
  const observedCloseButtons = new WeakSet();
  function observeReviewCloseButtons(root) {
    const buttons = root.matches?.(closeSelector) ? [root] : root.querySelectorAll(closeSelector);
    for (const button of buttons) {
      if (observedCloseButtons.has(button)) continue;
      observedCloseButtons.add(button);
      const restoreAccess = () => {
        if (button.getAttribute('aria-hidden') === 'true') button.removeAttribute('aria-hidden');
        if (button.getAttribute('tabindex') === '-1') button.removeAttribute('tabindex');
      };
      restoreAccess();
      new MutationObserver(restoreAccess).observe(button, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'tabindex']
      });
    }
  }
  observeReviewCloseButtons(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) observeReviewCloseButtons(node);
      }
    }
  }).observe(document.body, {childList: true, subtree: true});
  customElements.define('nx-review-rating', NaturexReviewRating);
  customElements.define('nx-product-reviews', NaturexProductReviews);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-storefront-polish"] && !Shopify.designMode) return;
  try {
    (() => {
  const observedTables = new WeakSet();
  const enhanceTable = (wrap) => {
    if (wrap.scrollWidth <= wrap.clientWidth + 1) return;
    const language = document.getElementById('nx-form-language');
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', wrap.querySelector('caption')?.textContent.trim() || language?.dataset.table || '');
  };
  const tableObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      enhanceTable(entry.target);
      tableObserver.unobserve(entry.target);
    });
  }, { rootMargin: '400px 0px' }) : null;
  const enhance = () => {
    const language = document.getElementById('nx-form-language');
    if (!language) return;
    document.querySelectorAll('#MainContent form').forEach((form, index) => {
      const type = form.querySelector('input[name="form_type"]');
      if (!type || !['customer', 'contact'].includes(type.value) || form.dataset.nxPolished) return;
      form.dataset.nxPolished = 'true';
      const feedback = document.createElement('p');
      feedback.id = `nx-form-feedback-${index}`;
      feedback.className = 'nx-form-feedback';
      feedback.setAttribute('role', 'alert');
      feedback.hidden = true;
      form.prepend(feedback);
      const fields = [...form.querySelectorAll('input:not([type="hidden"]),select,textarea')];
      const validate = (field) => {
        field.setCustomValidity('');
        let message = '';
        if (field.validity.valueMissing) message = language.dataset.required;
        else if (field.type === 'email' && field.validity.typeMismatch) message = language.dataset.email;
        if (message) field.setCustomValidity(message);
        return message;
      };
      fields.forEach((field) => {
        if (field.type === 'email') {
          field.setAttribute('inputmode', 'email');
          field.setAttribute('autocapitalize', 'off');
          field.spellcheck = false;
        }
        field.addEventListener('input', () => {
          field.setCustomValidity('');
          field.removeAttribute('aria-invalid');
          const described = (field.getAttribute('aria-describedby') || '').split(' ').filter(id => id && id !== feedback.id);
          if (described.length) field.setAttribute('aria-describedby', described.join(' '));
          else field.removeAttribute('aria-describedby');
          feedback.hidden = true;
        });
        field.addEventListener('invalid', () => {
          const message = validate(field);
          field.setAttribute('aria-invalid', 'true');
          const described = new Set((field.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
          described.add(feedback.id);
          field.setAttribute('aria-describedby', [...described].join(' '));
          feedback.textContent = message || field.validationMessage;
          feedback.hidden = false;
        });
      });
      const result = [...form.querySelectorAll('[role="status"],[role="alert"]')].find(el => el !== feedback && el.textContent.trim());
      if (result) {
        result.setAttribute('tabindex', '-1');
        requestAnimationFrame(() => result.focus());
      }
    });
    document.querySelectorAll('#MainContent .nx-product__table-wrap').forEach((wrap) => {
      if (observedTables.has(wrap)) return;
      observedTables.add(wrap);
      if (tableObserver) tableObserver.observe(wrap);
      else enhanceTable(wrap);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();
  } catch(e) { console.error(e); }
})();

})();
